<div class="container" fxLayout="column" fxFlex="690px" fxFlex.lt-md="90%">
	<h2 i18n="@@OrderCancelledHeader">Payment cancelled!</h2>
	<p i18n="@@OrderCancelledNote">
		Currently online payment cannot be retried. If you have registered an account, you can see the
		pending order in your profile and copy the products to the cart and make a new order.
	</p>
	<button class="btn btn-primary" [routerLink]="['']" i18n>Homepage</button>
</div>
